export default "__VITE_ASSET__D5UOQ6H7__"